// 'admin' namespace — keys are prefixed 'admin.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'admin.title': 'Администрирование',
  'admin.subtitle': 'Доступ, роли, ИИ, расходы, контент и журнал действий.',
  'admin.tab.allowlist': 'Доступ и роли',
  'admin.tab.ai': 'ИИ и модели',
  'admin.tab.usage': 'Расходы',
  'admin.tab.content': 'Контент',
  'admin.tab.audit': 'Журнал',
  'admin.never': 'никогда',
  'admin.noMatches': 'Ничего не найдено',
  'admin.reset': 'Отменить изменения',

  'admin.allowlist.addTitle': 'Добавить адрес',
  'admin.allowlist.addHelp': 'Войти могут только адреса из этого списка. Роль выдаётся при первом входе.',
  'admin.allowlist.email': 'Эл. почта',
  'admin.allowlist.role': 'Роль',
  'admin.allowlist.sendInvite': 'Отправить приглашение',
  'admin.allowlist.add': 'Добавить',
  'admin.allowlist.added': 'Адрес добавлен',
  'admin.allowlist.addedInvited': 'Адрес добавлен, приглашение отправлено',
  'admin.allowlist.listTitle': 'Список доступа',
  'admin.allowlist.filter': 'Найти адрес',
  'admin.allowlist.empty': 'Список доступа пуст',
  'admin.allowlist.you': 'вы',
  'admin.allowlist.disabled': 'доступ закрыт',
  'admin.allowlist.lastLogin': 'Последний вход: {date}',
  'admin.allowlist.notSignedIn': 'Ещё не входил',
  'admin.allowlist.addedBy': 'добавил {who}',
  'admin.allowlist.roles': 'Роли',
  'admin.allowlist.rolesAfterLogin': 'Роли можно менять после первого входа пользователя',
  'admin.allowlist.oneRole': 'Должна остаться хотя бы одна роль',
  'admin.allowlist.revoke': 'Закрыть доступ',
  'admin.allowlist.restore': 'Вернуть доступ',
  'admin.allowlist.cannotRevokeSelf': 'Нельзя закрыть доступ самому себе',
  'admin.allowlist.revokeTitle': 'Закрыть доступ для {email}?',
  'admin.allowlist.revokeText': 'Адрес будет отключён, все активные сеансы этого пользователя завершатся сразу. Его работы сохранятся; доступ можно вернуть позже.',
  'admin.allowlist.revoked': 'Доступ закрыт, сеансы завершены',

  'admin.ai.provider': 'Провайдер',
  'admin.ai.providerHelp': 'Через кого распознаётся почерк и проверяются тексты. Выбрать можно только провайдера, для которого на сервере задан ключ.',
  'admin.ai.configured': 'ключ задан',
  'admin.ai.notConfigured': 'не настроен',
  'admin.ai.active': 'Активный провайдер',
  'admin.ai.p.anthropic': 'Anthropic',
  'admin.ai.p.openai': 'OpenAI',
  'admin.ai.p.mock': 'Тестовый (mock)',
  'admin.ai.mockWarn': 'Тестовый провайдер возвращает заготовленные ответы — не используйте его для реальной учёбы.',
  'admin.ai.noSecrets': 'Ключи API хранятся только в переменных окружения сервера и здесь не отображаются.',
  'admin.ai.models': 'Модели',
  'admin.ai.modelsHelp': 'Идентификаторы моделей для распознавания почерка и для оценки. Пустое поле — значение по умолчанию с сервера.',
  'admin.ai.visionModel': 'Распознавание (vision)',
  'admin.ai.evaluationModel': 'Оценка текста',
  'admin.ai.defaultModel': 'по умолчанию',
  'admin.ai.costUnknown': 'Цена для этой модели не настроена — стоимость будет «неизвестно».',
  'admin.ai.unpriced': 'Для моделей {models} не задана цена (AI_PRICING_JSON). Расходы по ним будут показаны как неизвестные, и бюджет не сможет их учесть.',
  'admin.ai.budget': 'Месячный бюджет, USD',
  'admin.ai.budgetHelp': 'При исчерпании новые проверки ИИ приостанавливаются до следующего месяца.',
  'admin.ai.budgetInvalid': 'Введите сумму от 0 до 10 000.',
  'admin.ai.teacherFeature': 'Функция «преподаватель»',
  'admin.ai.teacherFeatureHelp': 'Позволяет ученикам делиться работами с приглашёнными преподавателями.',
  'admin.ai.saved': 'Настройки сохранены',

  'admin.usage.monthToDate': 'Расходы ИИ с начала месяца',
  'admin.usage.nearBudget': 'Близко к лимиту',
  'admin.usage.overBudget': 'Бюджет исчерпан',
  'admin.usage.budgetNote': 'Использовано {pct}% месячного бюджета (UTC).',
  'admin.usage.inputTokens': 'Входные токены',
  'admin.usage.outputTokens': 'Выходные токены',
  'admin.usage.jobs': 'Задач',
  'admin.usage.failed': 'С ошибкой',
  'admin.usage.storage': 'Файлы',
  'admin.usage.files': 'файлов: {n}',
  'admin.usage.db': 'База данных',
  'admin.usage.backup': 'Резервная копия',
  'admin.usage.noBackupStatus': 'статус неизвестен',
  'admin.usage.backup.missing': 'Нет сведений о резервном копировании — проверьте задание бэкапа.',
  'admin.usage.backup.failed': 'Последнее резервное копирование завершилось ошибкой.',
  'admin.usage.backup.stale': 'Последней копии больше 36 часов.',
  'admin.usage.recent': 'Последние задачи ИИ',
  'admin.usage.noJobs': 'Задач пока не было.',
  'admin.usage.col.time': 'Время',
  'admin.usage.col.type': 'Тип',
  'admin.usage.col.status': 'Статус',
  'admin.usage.col.model': 'Модель',
  'admin.usage.col.tokens': 'Токены вх./вых.',
  'admin.usage.col.latency': 'Время ответа',
  'admin.usage.col.cost': 'Стоимость',
  'admin.usage.costUnknown': 'неизвестно',
  'admin.usage.type.transcribe': 'Распознавание',
  'admin.usage.type.evaluate': 'Оценка',

  'admin.content.importTitle': 'Импорт заданий (JSON)',
  'admin.content.importHelp': 'Файл в формате библиотеки контента: sources и tasks. Сначала проверка без записи, затем импорт. Повторный импорт обновляет задания по ключу.',
  'admin.content.chooseFile': 'Выбрать файл',
  'admin.content.jsonLabel': 'Содержимое JSON',
  'admin.content.dryRun': 'Проверить',
  'admin.content.import': 'Импортировать',
  'admin.content.dryRunFirst': 'Импорт станет доступен после успешной проверки.',
  'admin.content.invalidJson': 'Некорректный JSON: {msg}',
  'admin.content.tooLarge': 'Файл больше 2 МБ',
  'admin.content.schemaIssues': 'Файл не соответствует схеме ({n})',
  'admin.content.dryRunOk': 'Проверка пройдена. Предупреждений: {n}',
  'admin.content.dryRunFailed': 'Есть ошибки — импорт невозможен',
  'admin.content.level.error': 'ошибка',
  'admin.content.level.warning': 'внимание',
  'admin.content.imported': 'Импорт выполнен',
  'admin.content.importDone': 'Импорт завершён',
  'admin.content.stats': 'Источников: {sources}. Новых заданий: {created}, обновлено: {updated}, новых образцов: {refs}, без изменений: {unchanged}.',
  'admin.content.tasks': 'Задания',
  'admin.content.search': 'Ключ или название',
  'admin.content.statusFilter': 'Фильтр по статусу',
  'admin.content.noTasks': 'В библиотеке нет заданий',
  'admin.content.status.active': 'Активно',
  'admin.content.status.archived': 'В архиве',
  'admin.content.status.flagged': 'На проверке',
  'admin.content.changeStatus': 'Статус задания {key}',
  'admin.content.statusChanged': 'Статус обновлён',

  'admin.audit.help': 'Изменения доступа, ролей, настроек и контента.',
  'admin.audit.filter': 'Действие или пользователь',
  'admin.audit.limit': 'Сколько записей',
  'admin.audit.lastN': 'последние {n}',
  'admin.audit.empty': 'Журнал пуст',
  'admin.audit.system': 'система',
  'admin.audit.col.time': 'Время',
  'admin.audit.col.actor': 'Кто',
  'admin.audit.col.action': 'Действие',
  'admin.audit.col.entity': 'Объект',
  'admin.audit.col.details': 'Подробности',
};

const en: Record<string, string> = {
  'admin.title': 'Administration',
  'admin.subtitle': 'Access, roles, AI, costs, content and the audit log.',
  'admin.tab.allowlist': 'Access & roles',
  'admin.tab.ai': 'AI & models',
  'admin.tab.usage': 'Usage',
  'admin.tab.content': 'Content',
  'admin.tab.audit': 'Audit log',
  'admin.never': 'never',
  'admin.noMatches': 'No matches',
  'admin.reset': 'Discard changes',

  'admin.allowlist.addTitle': 'Add an address',
  'admin.allowlist.addHelp': 'Only addresses on this list can sign in. The role is granted on first sign-in.',
  'admin.allowlist.email': 'Email',
  'admin.allowlist.role': 'Role',
  'admin.allowlist.sendInvite': 'Send invitation',
  'admin.allowlist.add': 'Add',
  'admin.allowlist.added': 'Address added',
  'admin.allowlist.addedInvited': 'Address added, invitation sent',
  'admin.allowlist.listTitle': 'Allowlist',
  'admin.allowlist.filter': 'Find an address',
  'admin.allowlist.empty': 'The allowlist is empty',
  'admin.allowlist.you': 'you',
  'admin.allowlist.disabled': 'access closed',
  'admin.allowlist.lastLogin': 'Last sign-in: {date}',
  'admin.allowlist.notSignedIn': 'Has not signed in yet',
  'admin.allowlist.addedBy': 'added by {who}',
  'admin.allowlist.roles': 'Roles',
  'admin.allowlist.rolesAfterLogin': 'Roles can be edited after the user’s first sign-in',
  'admin.allowlist.oneRole': 'At least one role must remain',
  'admin.allowlist.revoke': 'Revoke access',
  'admin.allowlist.restore': 'Restore access',
  'admin.allowlist.cannotRevokeSelf': 'You cannot revoke your own access',
  'admin.allowlist.revokeTitle': 'Revoke access for {email}?',
  'admin.allowlist.revokeText': 'The address is disabled and all of this user’s active sessions end immediately. Their work is kept; access can be restored later.',
  'admin.allowlist.revoked': 'Access revoked, sessions ended',

  'admin.ai.provider': 'Provider',
  'admin.ai.providerHelp': 'Who recognises handwriting and evaluates texts. Only providers with a key configured on the server can be selected.',
  'admin.ai.configured': 'key set',
  'admin.ai.notConfigured': 'not configured',
  'admin.ai.active': 'Active provider',
  'admin.ai.p.anthropic': 'Anthropic',
  'admin.ai.p.openai': 'OpenAI',
  'admin.ai.p.mock': 'Test (mock)',
  'admin.ai.mockWarn': 'The test provider returns canned answers — do not use it for real study.',
  'admin.ai.noSecrets': 'API keys live only in the server environment and are never shown here.',
  'admin.ai.models': 'Models',
  'admin.ai.modelsHelp': 'Model ids for handwriting recognition and for evaluation. Leave empty to use the server default.',
  'admin.ai.visionModel': 'Recognition (vision)',
  'admin.ai.evaluationModel': 'Text evaluation',
  'admin.ai.defaultModel': 'default',
  'admin.ai.costUnknown': 'No price configured for this model — cost will show as unknown.',
  'admin.ai.unpriced': 'No price is configured for {models} (AI_PRICING_JSON). Their cost will show as unknown and the budget cannot account for it.',
  'admin.ai.budget': 'Monthly budget, USD',
  'admin.ai.budgetHelp': 'When exhausted, new AI checks pause until next month.',
  'admin.ai.budgetInvalid': 'Enter an amount between 0 and 10,000.',
  'admin.ai.teacherFeature': 'Teacher feature',
  'admin.ai.teacherFeatureHelp': 'Lets students share work with invited teachers.',
  'admin.ai.saved': 'Settings saved',

  'admin.usage.monthToDate': 'AI cost month to date',
  'admin.usage.nearBudget': 'Close to the limit',
  'admin.usage.overBudget': 'Budget exhausted',
  'admin.usage.budgetNote': '{pct}% of the monthly budget used (UTC).',
  'admin.usage.inputTokens': 'Input tokens',
  'admin.usage.outputTokens': 'Output tokens',
  'admin.usage.jobs': 'Jobs',
  'admin.usage.failed': 'Failed',
  'admin.usage.storage': 'Files',
  'admin.usage.files': '{n} files',
  'admin.usage.db': 'Database',
  'admin.usage.backup': 'Backup',
  'admin.usage.noBackupStatus': 'status unknown',
  'admin.usage.backup.missing': 'No backup status found — check the backup job.',
  'admin.usage.backup.failed': 'The last backup failed.',
  'admin.usage.backup.stale': 'The last backup is older than 36 hours.',
  'admin.usage.recent': 'Recent AI jobs',
  'admin.usage.noJobs': 'No jobs yet.',
  'admin.usage.col.time': 'Time',
  'admin.usage.col.type': 'Type',
  'admin.usage.col.status': 'Status',
  'admin.usage.col.model': 'Model',
  'admin.usage.col.tokens': 'Tokens in/out',
  'admin.usage.col.latency': 'Latency',
  'admin.usage.col.cost': 'Cost',
  'admin.usage.costUnknown': 'unknown',
  'admin.usage.type.transcribe': 'Recognition',
  'admin.usage.type.evaluate': 'Evaluation',

  'admin.content.importTitle': 'Import tasks (JSON)',
  'admin.content.importHelp': 'A content-library file with sources and tasks. Validate first (nothing is written), then import. Re-importing updates tasks by key.',
  'admin.content.chooseFile': 'Choose file',
  'admin.content.jsonLabel': 'JSON content',
  'admin.content.dryRun': 'Validate',
  'admin.content.import': 'Import',
  'admin.content.dryRunFirst': 'Import becomes available after a successful validation.',
  'admin.content.invalidJson': 'Invalid JSON: {msg}',
  'admin.content.tooLarge': 'File is larger than 2 MB',
  'admin.content.schemaIssues': 'File does not match the schema ({n})',
  'admin.content.dryRunOk': 'Validation passed. Warnings: {n}',
  'admin.content.dryRunFailed': 'There are errors — cannot import',
  'admin.content.level.error': 'error',
  'admin.content.level.warning': 'warning',
  'admin.content.imported': 'Import complete',
  'admin.content.importDone': 'Import finished',
  'admin.content.stats': 'Sources: {sources}. New tasks: {created}, updated: {updated}, new references: {refs}, unchanged: {unchanged}.',
  'admin.content.tasks': 'Tasks',
  'admin.content.search': 'Key or title',
  'admin.content.statusFilter': 'Filter by status',
  'admin.content.noTasks': 'The library has no tasks',
  'admin.content.status.active': 'Active',
  'admin.content.status.archived': 'Archived',
  'admin.content.status.flagged': 'Flagged',
  'admin.content.changeStatus': 'Status of task {key}',
  'admin.content.statusChanged': 'Status updated',

  'admin.audit.help': 'Changes to access, roles, settings and content.',
  'admin.audit.filter': 'Action or user',
  'admin.audit.limit': 'How many entries',
  'admin.audit.lastN': 'last {n}',
  'admin.audit.empty': 'The audit log is empty',
  'admin.audit.system': 'system',
  'admin.audit.col.time': 'Time',
  'admin.audit.col.actor': 'Who',
  'admin.audit.col.action': 'Action',
  'admin.audit.col.entity': 'Object',
  'admin.audit.col.details': 'Details',
};

export default { ru, en };
